export default __webpack_public_path__ + "static/media/carfax_logo.693ad59e.svg";